export var setLocale = function setLocale(locale) {
  return localeState.locale = locale;
};
var localeState = {
  locale: 'en'
};
export var getLocale = function getLocale() {
  return localeState.locale;
};
export var resetLocale = function resetLocale() {
  return setLocale('en');
};